// libs
import React, { memo, useState } from "react";
import { connect } from "react-redux";
import styled from "@emotion/styled";
import isEmpty from "lodash/isEmpty";

// components
import CategoryLink from "./components/CategoryLink";
import Category from "./components/Category";

// helpers
import { isDwebMenu, generateTrackingUrlForMegaMenu } from "shared/components/Header/helpers";

// redux selectors
import { getMenuData } from "shared/store/app/selectors";

// redux context
import MenuContext from "./MenuContext";

// constants
import { MENU_TYPE } from "shared/components/Header/constants";

// styles
const Nav = styled.nav`
    display: flex;
    height: 100%;
    width: 100%;
    align-items: center;
    justify-content: space-between;
`;

// defs
import { IMapOfString } from "global";
interface IMenuProps {
    menuData: any;
}

function Menu({ menuData }: IMenuProps) {
    const [currentSubCategory, updateSubCategory] = useState<number>(-1);
    let timer: NodeJS.Timeout;

    const onMouseIn = (id: number) => {
        if (timer !== null) {
            clearTimeout(timer);
        }

        timer = setTimeout(() => updateSubCategory(id), 50);
    };

    const onMouseOut = () => {
        if (timer !== null) {
            clearTimeout(timer);
        }

        timer = setTimeout(() => updateSubCategory(-1), 300);
    };

    const hideSubMenu = () => updateSubCategory(-1);

    const goToUrl = (data: IMapOfString) => {
        if (isEmpty(data)) {
            return;
        }

        // Hide Sub Menu on Click
        hideSubMenu();
        window.open(generateTrackingUrlForMegaMenu(data));
    };

    return (
        <MenuContext.Provider value={{ goToUrl, hideSubMenu }}>
            <Nav>
                {menuData
                    .filter(child => child.isActive && isDwebMenu(child))
                    .map((child, idx: number) => {
                        child.position = idx + 1;
                        switch (child.type) {
                            case MENU_TYPE.CATEGORY: {
                                const showSubCategory = child.id === currentSubCategory;
                                return (
                                    // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
                                    <Category
                                        key={idx}
                                        onMouseIn={onMouseIn}
                                        onMouseOut={onMouseOut}
                                        showSubCategory={showSubCategory}
                                        data={child}
                                    />
                                );
                            }

                            case MENU_TYPE.AD_PLATFORM_LINK:
                            case MENU_TYPE.SALE:
                            case MENU_TYPE.LINK: {
                                return <CategoryLink key={idx} data={child} />;
                            }
                        }
                    })}
            </Nav>
        </MenuContext.Provider>
    );
}

const mapStateToProps = (state: any) => ({
    menuData: getMenuData(state),
});

export default connect(mapStateToProps)(memo(Menu));
